import { DataTable, EmptyState, Layout, Page, Text, Link, Badge, Card } from '@shopify/polaris';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyIMG from '../../media/images/empty.png';
import Pagination from '../../components/pagination';
import helpers from '../../helpers';
import dateandtime from 'date-and-time';
import SkeletonLoading from 'components/skeletonPageLoading';
import SimpleFilter from 'components/simpleFilter';
import { ___ } from 'languages/index';
import { TypedSeating, useGetSeatings } from 'queries/seating.query';
import { Helmet } from 'react-helmet-async';
import SeatingModal from './seating.modal';
import { PlusIcon } from '@shopify/polaris-icons';

export default function VihicleList() {
  const [entities, setEntities] = useState<TypedSeating[]>([]);
  const [totalItems, setTotalItems] = useState(0);

  const history = useNavigate();

  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let { search } = useLocation();
  let StringQuery: any = helpers.ExtractUrl(search);

  const initialQuery = {
    query: '',
    page: 1,
    limit: 25,
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState({
    ...initialQuery,
    ...StringQuery,
  });

  const { data, refetch: getEntities, isPending: loading } = useGetSeatings(mainQuery);

  useEffect(() => {
    if (data) {
      setEntities(data.body);
      setTotalItems(data.totalItems);
    }
  }, [data]);

  /**
   * Change page number
   */
  const onChangePagination = useCallback(
    (numPage: number, limit: number) => {
      setMainQuery({ ...mainQuery, page: numPage, limit: limit });
    },
    [mainQuery]
  );

  /**
   * Double request!
   */
  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (search !== buildURLSearch) history('/seating' + buildURLSearch);
    getEntities();
  }, [mainQuery]);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  const [newModelactive, setNewModelactive] = useState(false);
  const toggleNewActive = useCallback(() => setNewModelactive((active) => !active), []);

  const currentVehicleID = useRef(null);

  const emptyData = (
    <EmptyState heading="Không có bản ghi!" image={emptyIMG}>
      <p>Oh, Không có gì ở đây. Hãy thử bỏ bộ lọc hoặc tạo mới.</p>
    </EmptyState>
  );

  const renderItem = (vehicle: TypedSeating) => {
    const { id, seating_name, seating_description, seating_available_count, seating_map, seating_number, seating_status, createdAt } = vehicle;
    return [
      id,
      <Link
        key={id}
        onClick={() => {
          currentVehicleID.current = id;
          toggleNewActive();
        }}
      >
        <div style={{ minWidth: '150px' }}>{helpers.trimContentString(seating_name)}</div>
      </Link>,
      <div style={{ minWidth: '150px' }}>{helpers.trimContentString(seating_description)}</div>,
      seating_number,
      seating_available_count,
      seating_status === 1 ? <Badge tone="success">Hoạt động</Badge> : <Badge tone="warning">Ngừng hoạt động</Badge>,
      createdAt ? dateandtime.format(new Date(Number(createdAt)), 'HH:mm:ss DD-MM-YYYY') : '-',
    ];
  };
  const PagesList =
    entities?.length > 0 ? (
      <>
        <DataTable
          hoverable
          fixedFirstColumns={2}
          columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text']}
          headings={['ID', 'Loại', 'Mô tả', 'Số ghế', 'Số chỗ mở bán', 'Tình trạng', 'Tạo']}
          rows={entities?.map(renderItem)}
          hideScrollIndicator
          footerContent={___('Show page {display_page_number} of {total_record_number} results', {
            display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
            total_record_number: <Text as="strong">{totalItems}</Text>,
          })}
        />
      </>
    ) : (
      emptyData
    );

  const Actual_page = (
    <>
      <Helmet>
        <title>Danh sách loại hình vận tải</title>
      </Helmet>
      <Page
        title="Danh sách loại hình vận tải"
        primaryAction={{
          content: 'Thêm loại hình',
          disabled: false,
          icon: PlusIcon,
          onAction: toggleNewActive,
        }}
      >
        <Layout>
          <Layout.Section>
            <Card padding="0">
              <SimpleFilter loading={loading} onCallback={filterCallback} options={[]} sortField={[]} />
              {PagesList}
            </Card>
            <br />
            {totalItems > mainQuery.limit ? (
              <Pagination TotalRecord={totalItems} activeCurrentPage={mainQuery.page} pageSize={mainQuery.limit} onChange={onChangePagination} />
            ) : null}
          </Layout.Section>
        </Layout>
      </Page>
      {
        <SeatingModal
          show={newModelactive}
          currentVehicleID={currentVehicleID.current}
          onClose={() => {
            currentVehicleID.current = null;
            setNewModelactive(false);
          }}
        />
      }
    </>
  );

  return <>{entities === null ? <SkeletonLoading /> : Actual_page}</>;
}

